import { createArrayStore } from './arrayStore';
import { LsKey } from '../lib/storage';
import { createThemeStore } from './theme';
export const favoriteLibraryNames = createArrayStore({
    storageKey: LsKey.FAVORITE_LIBRARY_NAMES,
});
export const theme = createThemeStore();
